/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import useAsegurados from 'redux/hooks/emision/useAsegurados';
import BeneficiariosForm from '../Form/BeneficiariosForm';

const ACCIONES = {
  ADD: 'add',
  EDIT: 'edit',
};

const ModalAddBeneficiario = ({
  asegurado = {},
  onClickButton,
  onClose,
  defaultValues = {},
  onSubmit = () => {},
  accion = ACCIONES.ADD,
  labelBtn = 'Agregar',
  allowCompleted = true,
  porcentajeEditar,
  beneficiarios = [],
}) => {
  const [show, setShow] = useState(false);

  const { catalogoBeneficiarios, getPorcentajes } = useAsegurados();

  const methods = useForm({ mode: 'onChange', defaultValues });

  useEffect(() => {
    methods.reset(defaultValues);
  }, [beneficiarios, accion]);

  const porcentajes = getPorcentajes(beneficiarios, porcentajeEditar);

  const handleClose = () => {
    onClose && onClose();
    setShow(false);
  };
  const handleShow = () => {
    onClickButton && onClickButton(asegurado);
    setShow(true);
  };

  return (
    <React.Fragment>
      <Button
        className="p-button-sm p-button-primary btn-block"
        label={
          (porcentajes.disponible === 0 && allowCompleted) ||
          beneficiarios.length === catalogoBeneficiarios.maxBeneficiarios
            ? 'COMPLETADO'
            : labelBtn
        }
        onClick={handleShow}
        disabled={
          (porcentajes.disponible === 0 && catalogoBeneficiarios.maxBeneficiarios) ||
          beneficiarios.length === 4
        }
      />

      <FormProvider {...methods}>
        <Modal
          show={show}
          onHide={handleClose}
          centered
          aria-labelledby="contained-modal-title-vcenter"
          size="lg"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h2>{ACCIONES.ADD === accion && 'Agregar beneficiario'}</h2>
              <h2>{ACCIONES.EDIT === accion && 'Editar beneficiario'}</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
            <BeneficiariosForm
              porcentajes={porcentajes}
              parentescos={catalogoBeneficiarios.parentescos}
            />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-sm btn-atras-api" onClick={handleClose}>
              Cerrar
            </button>
            <button
              className="btn btn-sm btn-siguiente-api"
              onClick={methods.handleSubmit(
                onSubmit({ asegurado, handleClose, accion, methods }),
              )}
            >
              Guardar
            </button>
          </Modal.Footer>
        </Modal>
      </FormProvider>
    </React.Fragment>
  );
};

export default ModalAddBeneficiario;
